import { RoadmapPortfolioDTO } from '@/domain/portfolio/types';
import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { registerResetFn } from '@/store/reset';
import { create } from 'zustand';

import { initialValue } from '../utils/initialValue';

export interface PlannedHoursRow {
  id: number;
  hours: number;
  resource: string;
  alias: string;
}

export interface RoadmapStore {
  following: number[];
  editableRoadMap: RoadMapUpdate;
  isStoreDirty: boolean;
  isPlannedHoursDirty: boolean;
  plannedHoursRows: PlannedHoursRow[];
  selectedPortfolio: RoadmapPortfolioDTO | null;
}

const initialState: RoadmapStore = {
  following: [],
  editableRoadMap: initialValue,
  isStoreDirty: false,
  isPlannedHoursDirty: false,
  plannedHoursRows: [],
  selectedPortfolio: null,
};

export const useRoadmapEditStore = create<RoadmapStore>()(() => ({
  ...initialState,
}));

registerResetFn(() => useRoadmapEditStore.setState(initialState));

export const addFollowingIds = (id: number) =>
  useRoadmapEditStore.setState((state) =>
    state.following.includes(id) ? state : { following: [...state.following, id] },
  );
